export default {
    items: [
        {label: 'Приход', value: 1,},
        {label: 'Расход', value: 2,}
    ]
}